import React from "react";
import { Button, Icon } from "antd";

export default function SideButton({clickAction}){
    return(
        <div id="sideButton">
            <Button 
                type="primary" 
                onClick={() => clickAction()}
                style={{height: 45}}
            >
                <Icon type="save" style={{fontSize: 25}}/>
            </Button>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/common/SideButton.jsx